import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';

export default function UploadCloud ({ isHovered, scale = 1 }) {
  const [iconScale, setIconScale] = useState(scale);

  useEffect(() => {
    if (validateScale(scale)) setIconScale(scale);
    else setIconScale(1)
  }, [scale])

  const arrowVariants = {
    initial: { y: 5 * iconScale }, // Scale the movement based on the scale factor
    hover: {
      y: -5 * iconScale,
      transition: {
        repeat: Infinity,
        repeatType: "reverse",
        duration: 1,
        ease: "easeInOut"
      }
    }
  };

  const size = 150 * iconScale;

  function validateScale(scale) {
    try {
      parseFloat(scale);
      return true;
    } catch {
      return false;
    }
  }


  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox={`0 0 100 100`} width={size} height={size} className="stroke-black stroke-2">
      <g transform={`scale(${iconScale})`} transform-origin="center">
        <motion.polygon
          className="fill-current text-black"
          points="41.3,57.7 42.1,58.5 49.5,51.1 49.5,74.8 50.5,74.8 50.5,51.1 57.9,58.5 58.7,57.7 50,49"
          variants={arrowVariants}
          animate={isHovered ? 'hover' : 'initial'}
        />
        <path
          d="M71.3 38.2c-.1 0-.2 0-.3 0-1.1-7.5-7.4-13-15.1-13-6.5 0-12.3 4.2-14.4 10.3-1.1-.3-2.3-.5-3.4-.5-6 0-11.1 4.4-12 10.3-.3 0-.6-.1-.9-.1-4.7 0-8.6 3.8-8.6 8.6 0 4.7 3.8 8.6 8.6 8.6h10.8v-1.1H25.2c-4.1 0-7.5-3.4-7.5-7.5 0-4.1 3.3-7.5 7.5-7.5.4 0 .8 0 1.3.1l.6.1.1-.6c.6-5.6 5.3-9.9 10.9-9.9 1.2 0 2.4.2 3.6.6l.5.2.2-.5c1.8-5.9 7.3-10.1 13.5-10.1 7.2 0 13.3 5.4 14 12.6l.1.5.5 0c.2 0 .5 0 .7 0 6.1 0 11 4.9 11 11 0 6.1-4.9 11-11 11h-7v1.1h7c6.7 0 12.1-5.4 12.1-12.1 0-6.7-5.4-12.1-12.1-12.1z"
          className="fill-current text-black"
        />
      </g>
    </svg>
  );
};
